'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils = require('../utils');
var range = require('@mx/util/range');

function getNow() {
  return window.performance && window.performance.now ? window.performance.now() + window.performance.timing.navigationStart : +new Date();
}

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      ref: "box",
      staticClass: "scroll-view",
      on: {
        "touchstart": _vm.onTouchStart,
        "touchmove": _vm.onTouchMove,
        "touchend": _vm.onTouchEnd,
        "touchcancel": _vm.onTouchEnd
      }
    }, [_c('div', {
      ref: "content",
      staticClass: "scroll-view-content",
      style: _vm.style
    }, [_vm._t("default")], 2)]);
  },
  staticRenderFns: [],
  name: 'scroll-view',
  props: {
    contentKey: [Number, Object],
    scrollX: {
      type: Boolean
    },
    scrollY: {
      type: Boolean
    },
    bounce: {
      type: Number
    },
    bounceDuration: {
      type: Number,
      default: 200
    },
    bounceTimingFunction: {
      type: String,
      default: 'cubic-bezier(0.23, 1, 0.32, 1)'
    },
    mode: {
      type: String // smooth slide

    },
    slide: {
      type: String,
      default: '100%'
    },
    slideIndex: {
      type: Number,
      default: 0
    },
    slideDuration: {
      type: Number,
      default: 200
    },
    slideTimingFunction: {
      type: String,
      default: 'initial'
    },
    smoothDuration: {
      type: Number,
      default: 2500
    },
    smoothTimingFunction: {
      type: String,
      default: 'cubic-bezier(0.33, 0.66, 0.66, 1)'
    }
  },
  data: function data() {
    return {
      slideWidth: 0,
      computed: false,
      startTime: 0,
      endTime: 0,
      bouncing: false,
      startX: 0,
      startY: 0,
      deltaX: 0,
      deltaY: 0,
      offsetX: 0,
      offsetY: 0,
      direction: '',
      duration: 0,
      timingFunction: 'initial',
      minOffsetX: 0,
      minOffsetY: 0,
      maxOffsetX: 0,
      maxOffsetY: 0,
      contentWidth: 0,
      maxSlideIndex: 0
    };
  },
  computed: {
    style: function style() {
      var _style = {
        transitionDuration: "".concat(this.duration, "ms"),
        transform: "translate(".concat(this.offsetX + this.deltaX, "px, ").concat(this.offsetY + this.deltaY, "px)"),
        transitionTimingFunction: this.timingFunction
      };

      if (this.scrollX && this.contentWidth) {
        _style.width = this.contentWidth + 'px';
      }

      return _style;
    }
  },
  created: function created() {
    var _this = this;

    this.$on('scrollX', function (x) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      _this.duration = duration;
      _this.offsetX = x;
    });
    this.$on('scrollY', function (y) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      _this.duration = duration;
      _this.offsetY = y;
    });
    this.$on('refresh', function () {
      _this.contentChange();
    });
  },
  mounted: function mounted() {
    if (this.scrollX && this.mode === 'slide') {
      this.slideIndexChange();
    }
  },
  methods: {
    contentChange: function contentChange() {
      this.computed = false;
    },
    computeSize: function computeSize() {
      this.computed = true;
      var boxRect = this.$refs.box.getBoundingClientRect();
      var contentRect = this.$refs.content.getBoundingClientRect();
      this.minOffsetY = boxRect.height - contentRect.height;

      if (this.scrollX) {
        var children = this.$refs.content.children;
        this.contentWidth = 0;

        for (var i = 0, len = children.length; i < len; i++) {
          this.contentWidth += children[i].clientWidth;
        }

        this.minOffsetX = boxRect.width - this.contentWidth;

        if (this.mode === 'slide') {
          if (this.slide.slice(-1) === '%') {
            this.slideWidth = boxRect.width * Number(this.slide.slice(0, -1)) / 100;
          } else {
            this.slideWidth = Number(this.slide);
          }
        }

        this.maxSlideIndex = Math.ceil(this.contentWidth / this.slideWidth) - 1;
      }
    },
    onTouchStart: function onTouchStart(event) {
      this.deltaX = 0;
      this.deltaY = 0;
      this.duration = 0;
      this.direction = '';
      this.startX = event.touches[0].clientX;
      this.startY = event.touches[0].clientY;

      if (this.mode === 'smooth') {
        this.startTime = getNow();
      }
    },
    onTouchMove: function onTouchMove(event) {
      // 防止滚动穿透
      if (this.scrollY) {
        event.preventDefault();
      }

      this.direction = this.direction || this.getDirection(event.touches[0]);
      var moveX, moveY;

      if (this.scrollX && this.direction === 'horizontal') {
        moveX = event.touches[0].clientX - this.startX;
        event.preventDefault();
      }

      if (this.scrollY && this.direction === 'vertical') {
        moveY = event.touches[0].clientY - this.startY;
      }

      this.computeOffset(moveX, moveY);
    },
    onTouchEnd: function onTouchEnd() {
      if (this.bouncing) {
        this.startBounce();
        return;
      } // smooth 惯性滚动


      if (!this.bouncing && this.mode === 'smooth') {
        this.endTime = getNow();
        var properTime = this.endTime - this.startTime < 300;
        var properMove = Math.abs(this.deltaX) > 15 || Math.abs(this.deltaY) > 15;

        if (properTime && properMove) {
          this.computeSmoothOffset(this.deltaX, this.deltaY);
          this.timingFunction = this.smoothTimingFunction;
        }
      }

      if (!this.bouncing && this.mode === 'slide' && this.scrollX) {
        if (Math.abs(this.deltaX) > this.slideWidth * 0.15) {
          var sign = this.deltaX > 0 ? 1 : -1;
          this.$emit('update:slideIndex', this.slideIndex - sign);
        }

        this.deltaX = 0;
      }

      this.offsetX += this.deltaX;
      this.offsetY += this.deltaY;
      this.deltaX = 0;
      this.deltaY = 0;
      this.$emit('scrollEnd', this.offsetX);
    },
    startBounce: function startBounce() {
      // bounce 回弹
      this.bouncing = false;
      this.duration = this.bounceDuration;
      this.timingFunction = this.bounceTimingFunction;
      this.offsetX = range.range(this.offsetX + this.deltaX, [this.minOffsetX, this.maxOffsetX]);
      this.offsetY = range.range(this.offsetY + this.deltaY, [this.minOffsetY, this.maxOffsetY]);
      this.deltaX = 0;
      this.deltaY = 0;
      this.$emit('bounceStart', this.offsetX);
    },
    computeOffset: function computeOffset(moveX, moveY) {
      if (!this.computed) {
        this.computeSize();
      }

      if (moveX && this.minOffsetX < this.maxOffsetX) {
        this.deltaX = this.getOffset(moveX, this.minOffsetX - this.offsetX, this.maxOffsetX - this.offsetX);
      }

      if (moveY && this.minOffsetY < this.maxOffsetY) {
        this.deltaY = this.getOffset(moveY, this.minOffsetY - this.offsetY, this.maxOffsetY - this.offsetY);
      }
    },
    computeSmoothOffset: function computeSmoothOffset(moveX, moveY) {
      var deceleration = 0.001;
      var speedX = 0,
          speedY = 0;

      if (this.scrollX) {
        speedX = Math.abs(moveX) / (this.endTime - this.startTime);
        var distX = speedX * speedX / (2 * deceleration) * (moveX > 0 ? 1 : -1);
        this.deltaX = range.range(distX, [this.minOffsetX - this.offsetX, this.maxOffsetX - this.offsetX]);
      }

      if (this.scrollY) {
        speedY = Math.abs(moveY) / (this.endTime - this.startTime);
        var distY = speedY * speedY / (2 * deceleration) * (moveY > 0 ? 1 : -1);
        this.deltaY = range.range(distY, [this.minOffsetY - this.offsetY, this.maxOffsetY - this.offsetY]);
      }

      this.duration = Math.max(speedX, speedY) / deceleration;
    },
    getOffset: function getOffset(move, minMove, maxMove) {
      if (this.bounce) {
        if (move < minMove) {
          return minMove + this.getBounceOffset(move - minMove);
        } else if (move > maxMove) {
          return maxMove + this.getBounceOffset(move - maxMove);
        } else {
          return move;
        }
      } else {
        return range.range(move, [minMove, maxMove]);
      }
    },
    getDirection: function getDirection(touch) {
      var distanceX = Math.abs(touch.clientX - this.startX);
      var distanceY = Math.abs(touch.clientY - this.startY);
      return distanceX > distanceY ? 'horizontal' : distanceX < distanceY ? 'vertical' : '';
    },
    getBounceOffset: function getBounceOffset(offset) {
      if (!this.bounce) {
        return 0;
      }

      this.bouncing = true;
      var sign = offset > 0 ? 1 : -1;
      offset = Math.abs(offset / (this.bounce * 3));
      offset = this.easeOut(offset);
      offset = Math.round(offset * this.bounce);
      return sign * offset;
    },
    easeOut: function easeOut(percent) {
      return percent >= 1 ? 1 : --percent * percent * percent + 1;
    },
    slideIndexChange: function slideIndexChange() {
      if (!this.computed) {
        this.computeSize();
      }

      var index = range.range(this.slideIndex, [0, this.maxSlideIndex]);

      if (this.slideIndex !== index) {
        this.$emit('update:slideIndex', index);
        return;
      }

      this.duration = this.slideDuration;
      this.timingFunction = this.slideTimingFunction;
      this.offsetX = -this.slideIndex * this.slideWidth;
    }
  },
  watch: {
    contentKey: function contentKey() {
      this.contentChange();
    },
    slideIndex: function slideIndex() {
      this.slideIndexChange();
    }
  }
});

exports.default = index;
